// Module
var code = "<div style=\"{{^.visible}}display: none;{{/}}\"></div>";
// Exports
export default code;